import { oembedId } from './OembedStore';

import { oembedIdDefault } from './OembedStoreDefaults';

export const resetOembedId = () => {
	oembedId.set(oembedIdDefault);
};
